module.exports = __webpack_public_path__ + "static/img/equipmentu1.cf843204.webp";